module.exports = __webpack_public_path__ + "static/img/progress-cn.da86125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/progress/progress-cn.png
// module id = erV1
// module chunks = 1